export const beforeEnter = (el: Element) => {
  const element = el as HTMLElement;
  element.style.height = '0';
  element.style.opacity = '0';
};

export const enter = (el: Element) => {
  const element = el as HTMLElement;
  element.style.transition = 'height 0.3s ease, opacity 0.3s ease';
  element.style.height = element.scrollHeight + 'px';
  element.style.opacity = '1';
};

export const leave = (el: Element) => {
  const element = el as HTMLElement;
  element.style.transition = 'height 0.3s ease, opacity 0.3s ease';
  element.style.height = '0';
  element.style.opacity = '0';
};
